// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const MsPowerPointIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path
      fill="url(#ms-power-point_svga)"
      d="M22 11.58C22 6.3 17.67 2 12.32 2a9.63 9.63 0 0 0-9.68 9.58c0 5.3 4.34 9.59 9.68 9.59S22 16.87 22 11.58"
    />
    <path
      fill="url(#ms-power-point_svgb)"
      d="M22 11.58C22 6.3 17.67 2 12.32 2a9.63 9.63 0 0 0-9.68 9.58c0 5.3 4.34 9.59 9.68 9.59S22 16.87 22 11.58"
    />
    <path
      fill="url(#ms-power-point_svgc)"
      d="M22 11.58C22 6.3 17.67 2 12.32 2a9.63 9.63 0 0 0-9.68 9.58c0 5.3 4.34 9.59 9.68 9.59S22 16.87 22 11.58"
    />
    <path
      fill="url(#ms-power-point_svgd)"
      d="M12.32 2C17.67 2 22 6.3 22 11.58c0 1.76-.48 3.41-1.32 4.83l.16-.34c.96-2.1-.6-4.5-2.93-4.49h-3.85c-.96 0-1.74-.77-1.74-1.71V6.05c0-2.31-2.4-3.85-4.53-2.9l-.31.14A9.7 9.7 0 0 1 12.32 2"
    />
    <path
      fill="url(#ms-power-point_svge)"
      d="M12.32 2C17.67 2 22 6.3 22 11.58c0 1.76-.48 3.41-1.32 4.83l.16-.34c.96-2.1-.6-4.5-2.93-4.49h-3.85c-.96 0-1.74-.77-1.74-1.71V6.05c0-2.31-2.4-3.85-4.53-2.9l-.31.14A9.7 9.7 0 0 1 12.32 2"
    />
    <path
      fill="url(#ms-power-point_svgf)"
      d="M12.32 2C17.67 2 22 6.3 22 11.58c0 1.76-.48 3.41-1.32 4.83l.16-.34c.96-2.1-.6-4.5-2.93-4.49h-3.85c-.96 0-1.74-.77-1.74-1.71V6.05c0-2.31-2.4-3.85-4.53-2.9l-.31.14A9.7 9.7 0 0 1 12.32 2"
    />
    <path
      fill="url(#ms-power-point_svgg)"
      d="M12.32 2C17.67 2 22 6.3 22 11.58c0 1.76-.48 3.41-1.32 4.83l.16-.34c.96-2.1-.6-4.5-2.93-4.49h-3.85c-.96 0-1.74-.77-1.74-1.71V6.05c0-2.31-2.4-3.85-4.53-2.9l-.31.14A9.7 9.7 0 0 1 12.32 2"
    />
    <path
      fill="url(#ms-power-point_svgh)"
      d="M12.32 2C17.67 2 22 6.3 22 11.58c0 1.76-.48 3.41-1.32 4.83l.16-.34c.96-2.1-.6-4.5-2.93-4.49h-3.85c-.96 0-1.74-.77-1.74-1.71V6.05c0-2.31-2.4-3.85-4.53-2.9l-.31.14A9.7 9.7 0 0 1 12.32 2"
    />
    <path
      fill="url(#ms-power-point_svgi)"
      d="M3.68 11.07h4.9c.93 0 1.68.75 1.68 1.66v4.86c0 .92-.75 1.66-1.68 1.66h-4.9c-.93 0-1.68-.74-1.68-1.66v-4.86c0-.91.75-1.66 1.68-1.66"
    />
    <path
      fill="url(#ms-power-point_svgj)"
      d="M3.68 11.07h4.9c.93 0 1.68.75 1.68 1.66v4.86c0 .92-.75 1.66-1.68 1.66h-4.9c-.93 0-1.68-.74-1.68-1.66v-4.86c0-.91.75-1.66 1.68-1.66"
    />
    <path
      fill="#fff"
      d="M5.73 15.98v1.52H4.66v-4.67H6.3q.9 0 1.35.38t.46 1.13q0 .76-.52 1.2-.5.45-1.39.44zm0-2.35v1.54h.44q.4 0 .6-.2.22-.21.22-.6 0-.35-.2-.54-.22-.2-.6-.2z"
    />
    <defs>
      <radialGradient
        id="ms-power-point_svgb"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-13.7398 13.6062 -23.1259 -22.9011 16.15 7.56)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.15} stopColor="#AA1D2D" />
        <stop offset={0.38} stopColor="#D12B18" stopOpacity={0.44} />
        <stop offset={0.6} stopColor="#FF3C00" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="ms-power-point_svgc"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(16.6552 -7.7904 14.252 29.8799 -.73 19.37)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.41} stopColor="#FF66FB" stopOpacity={0.5} />
        <stop offset={1} stopColor="#EA3D01" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="ms-power-point_svge"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(12.2453 2.54101 -2.44624 11.5605 10.7 12.73)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.79} stopColor="#FFA05C" stopOpacity={0} />
        <stop offset={0.9} stopColor="#FFCE84" />
      </radialGradient>
      <radialGradient
        id="ms-power-point_svgf"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(10.5713 -6.84984 6.61489 10.0112 12.66 11.44)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.3} stopColor="#FF99E9" stopOpacity={0.8} />
        <stop offset={0.73} stopColor="#FF99E9" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="ms-power-point_svgg"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(8.84846 -10.0318 9.2518 8.00253 11.24 12.9)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FD6EF9" />
        <stop offset={0.64} stopColor="#F94" />
        <stop offset={0.85} stopColor="#FCC479" />
      </radialGradient>
      <radialGradient
        id="ms-power-point_svgh"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-.99949 6.70683 -15.3064 -2.23689 10.36 3.27)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.14} stopColor="#FF8D13" />
        <stop offset={0.54} stopColor="#FF7F29" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="ms-power-point_svgi"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="scale(11.67935 11.5658)rotate(45 -1.07 .69)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F8193E" />
        <stop offset={0.94} stopColor="#920616" />
      </radialGradient>
      <radialGradient
        id="ms-power-point_svgj"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(0 5.72478 -6.58103 0 6.13 15.98)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.58} stopColor="#FFB055" stopOpacity={0} />
        <stop offset={0.97} stopColor="#FFF2BE" stopOpacity={0.3} />
      </radialGradient>
      <linearGradient
        id="ms-power-point_svga"
        x1={11.34}
        x2={-0.41}
        y1={1.39}
        y2={12.74}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.06} stopColor="#FF7F48" />
        <stop offset={1} stopColor="#E5495B" />
      </linearGradient>
      <linearGradient
        id="ms-power-point_svgd"
        x1={14.15}
        x2={24.5}
        y1={13.72}
        y2={5.97}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.31} stopColor="#FF6E30" />
        <stop offset={0.63} stopColor="#FFA05C" />
      </linearGradient>
    </defs>
  </svg>,
  "MsPowerPoint",
);
export default MsPowerPointIcon;
